/* eslint-disable */
export default {
  searchPlaceholder: 'Suchen...',
  refresh: 'Aktualisieren',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
